export default "__VITE_ASSET__DS5Ej8S___"